import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AnnuityLetterService} from 'src/app/services/annuity-letter.service';
import {ErrorStateMatcher} from '@angular/material/core';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {AnnuityConfirmationDialogComponent} from '../../dialogs/annuity-confirmation-dialog/annuity-confirmation-dialog.component';
import {AsaasService} from 'src/app/services/asaas.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {Guid} from 'guid-typescript';
import {CieloService} from 'src/app/services/cielo.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';
import {CalableMemberService} from 'src/app/services/calable-member.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

const CURRENT_ANNUITY = "9tLOkTL9e7tqXtGz1jmA"
const CURRENT_ANNUITY_NAME = "Anuidades SBCCV"

@Component({
  selector: 'app-annuity-back',
  templateUrl: './annuity-back.component.html',
  styleUrls: [ './annuity-back.component.scss' ]
})
export class AnnuityBackComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public letter: any;
  public prices: any;

  public countAnnuitues: number = 0;
  public valueAnnuitues: number = 0;
  public valuePixAnnuitues: number = 0;
  public valueTotalAnnuitues: number = 0;
  public valueTotalPixAnnuitues: number = 0;

  public cardInstallments = [];
  public selectedOption: any;

  public entityForm: FormGroup;

  public msgErro: string = "";

  public param: any;
  public origin: string

  public payedDate: any;
  public isTester: boolean;

  public hasCredit: boolean = false;
  public discountValue: number = 0;
  public inputDisable = false;
  public msgCreditError: string = "";

  public invoiceUrl: string;
  public receiptUrl: string;

  public notFound: boolean;

  public receiptMessage: string;

  constructor (
    private _calableMemberService: CalableMemberService,
    private _asaasService: AsaasService,
    private _cieloService: CieloService,
    private _activeRoute: ActivatedRoute,
    private _annuityLetterService: AnnuityLetterService,
    private _dialog: MatDialog,
    private fb: FormBuilder,
    private _spinnerService: SpinnerService,
    private _router: Router,
  ) {
    this._activeRoute.params.subscribe(data => {
      this.param = data[ 'uid' ];

      const dataSplit = this.param.split(":")
      this.param = dataSplit[ 0 ] + ":" + dataSplit[ 1 ]; // "9tLOkTL9e7tqXtGz1jmA" = 1=26
      this.origin = dataSplit[ 2 ]

      if (!this.origin) this.origin = "web"

      // console.log("param:  " + this.param);
      // console.log("origin:  " + this.origin);

    })
  }

  async ngOnInit () {
    await this.loadLetter(this.param);
    this.entityForm = this.createForm();
  }

  async loadLetter (letter_id: string) {
    //console.log("lettter_id: " + letter_id);
    this._annuityLetterService.getLetterSentById(letter_id)
      .then((result) => {
        if (result) {
          this.notFound = false;
          this.letter = result
          //this.letter.name = this._annuityLetterService.decrypto(this.letter.name);

          // console.log("this.letter.email: " + this.letter.email)
          this.letter.email = this._annuityLetterService.decrypto(this.letter.email);
          // console.log("this.letter.email: " + this.letter.email)

          // console.log("this.letter.cpf: " + this.letter.cpf)
          this.letter.cpf = this._annuityLetterService.decrypto(this.letter.cpf);
          // console.log("this.letter.cpf: " + this.letter.cpf)

          this.letter.cellPhone = this._annuityLetterService.decrypto(this.letter.cellPhone);
          this.letter.address = this._annuityLetterService.decrypto(this.letter.address);
          this.letter.number = this._annuityLetterService.decrypto(this.letter.number);
          this.letter.complement = this._annuityLetterService.decrypto(this.letter.complement);
          this.letter.district = this._annuityLetterService.decrypto(this.letter.district);
          this.letter.city = this._annuityLetterService.decrypto(this.letter.city);
          this.letter.state = this._annuityLetterService.decrypto(this.letter.state);
          this.letter.country = this._annuityLetterService.decrypto(this.letter.country);
          this.letter.postalCode = this._annuityLetterService.decrypto(this.letter.postalCode);

          this.hasCredit = this.letter.credit > 0
          // console.log("letter: " + JSON.stringify(this.letter))
          this.isTester = this.letter.tester;
          //
          if (this.letter.datePayed) {
            this.payedDate = this.letter.datePayed;
            this.payedDate = this.formatDate(this.payedDate);
            this.receiptUrl = this.letter.receiptUrl;
            this.invoiceUrl = this.letter.invoiceUrl;
          } else {
            this.payedDate = null;
            this.getPrices()
          }
        } else {
          this.checkNotFound(this.param)
        }
      })
  }

  checkNotFound (letter_id: any) {
    const split = letter_id.split(":");
    const member_id = split[ 0 ];
    const product_id = split[ 1 ];

    // console.log("member_id:  " + member_id)
    // console.log("product_id:  " + product_id)
    this.notFound = true;

  }

  async getPrices () {
    // console.log("subCategory: " + this.letter.subCategory_id)

    const lot = await this._annuityLetterService.loadCurrentLot(CURRENT_ANNUITY)
    const categoriesPrices = await this._annuityLetterService.loadCurrentPrices(lot.id)

    this.prices = categoriesPrices.find((e) => {
      return e.id == this.letter.subCategory_id
    })

    if (this.prices) {
      // console.log("prices" + JSON.stringify(this.prices))
      this.letter.annuities.forEach((annuity) => {
        if (!annuity.isFree && annuity.value == 0) {
          annuity.product_name = annuity.product_name.substring(8, 13)
          this.countAnnuitues++
        }
      })

      this.valueAnnuitues = this.countAnnuitues * this.prices.value;
      this.valuePixAnnuitues = this.countAnnuitues * this.prices.value_pix;

      console.log(">>>>>> this.valueAnnuitues: " + this.valueAnnuitues);
      console.log(">>>>>> this.valuePixAnnuitues: " + this.valuePixAnnuitues);

      this.valueTotalAnnuitues = this.valueAnnuitues;
      this.valueTotalPixAnnuitues = this.valuePixAnnuitues;


      if (this.isTester) {
        // console.log("é tester -----------------------------")
        this.valueTotalAnnuitues = 10;
        this.valueTotalPixAnnuitues = 10;
      }

      this.makeCardInstalments();
    }

  }

  makeCardInstalments () {
    this.cardInstallments = [];
    for (let i = 1; i <= 6; i++) {
      const value = Number((this.valueTotalAnnuitues / i).toFixed(2));
      if (value >= 5) {
        this.cardInstallments.push({
          "installments": i,
          "value": value,
          "text": i == 1 ? "parcela no valor de " : "parcelas no valor de",
          "valueFormated": this.formatarEmReais(value)
        })

      }
    }
  }

  applyValueChange () {

    if (this.discountValue > this.letter.credit) {
      this.msgCreditError = "informe um valor abaixo de " + this.letter.credit;
    } else if (Number(this.valueTotalPixAnnuitues) - Number(this.discountValue) <= 5) {
      this.msgCreditError = "informe um valor abaixo  de " + this.discountValue;
    } else {

      this.msgCreditError = "";
      this.inputDisable = true;

      this.letter.credit = Number(this.letter.credit) - Number(this.discountValue);
      this.valueTotalAnnuitues = Number(this.valueTotalAnnuitues) - Number(this.discountValue);
      this.valueTotalPixAnnuitues = Number(this.valueTotalPixAnnuitues) - Number(this.discountValue);

      // console.log("credit: " + this.letter.credit)
      // console.log("discount: " + this.discountValue)


      this.makeCardInstalments();

    }

  }

  undoValueChange () {

    this.inputDisable = false;

    this.letter.credit = Number(this.letter.credit) + Number(this.discountValue);
    this.valueTotalAnnuitues = Number(this.valueTotalAnnuitues) + Number(this.discountValue);
    this.valueTotalPixAnnuitues = Number(this.valueTotalPixAnnuitues) + Number(this.discountValue);

    // console.log("credit: " + this.letter.credit)
    // console.log("discount value: " + this.discountValue)

    this.makeCardInstalments();

  }

  formatarEmReais (valor: number): string {
    const formatador = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Formata o valor e retorna a string
    return formatador.format(valor);
  }

  selectPaymentType (type: any) {

    // const objPayment: any = {};
    // objPayment.type = type;

    let paymentDoc: any = {}
    switch (type) {
      case "creditcard":
        {
          if (!this.selectedOption) {
            this.msgErro = "INFORME A QUANTIDADE DE PARCELAS!"
          } else {
            if (this.entityForm.valid) {
              const rawData = this.entityForm.getRawValue();
              paymentDoc = this.createCreditCard_cielo(rawData)
            }
            this.openDialogConfirmation(paymentDoc);
          }
        }
        break;
      case "billet":
        {
          this.selectedOption = null;
          paymentDoc = this.createBillet()
          this.openDialogConfirmation(paymentDoc);
        }
        break;
      case "pix":
        {
          this.selectedOption = null;
          paymentDoc = this.createPix_cielo()
          this.openDialogConfirmation(paymentDoc);
        }
        break;
    }

    // console.log("cielo payment: " + JSON.stringify(paymentDoc));


  }

  openDialogConfirmation (payment: any) {
    let dialogRef = this._dialog.open(AnnuityConfirmationDialogComponent, {
      width: '300px',
      height: '280px',
      panelClass: 'custom-dialog-container',
      data: payment
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ];

        if (actionType == "ok") {

          if (payment.gateway == "cielo") {
            //cielo processa o valor em centavos
            payment.payload.Payment.Amount = payment.payload.Payment.Amount * 100;
            // console.log("cielo payment: " + JSON.stringify(payment));
            this.createCieloPayment(payment)
          } else {
            console.log("assas payment: " + JSON.stringify(payment))
            this.createAsaasPayment(payment)
          }
        }

      })
  }

  async createCieloPayment (payment: any) {

    const waiting = this._spinnerService.show();
    //
    const result = await this._cieloService.cieloPayment(payment);
    //
    // console.log("cieloPayment result: " + JSON.stringify(result.success))
    // console.log("cieloPayment result.data: " + JSON.stringify(result.data))
    // console.log("-----------------------------------------------")
    //
    //
    // console.log("result.success------------: " + result.success)
    if (result.success === true) {
      //
      result.success = "success"
      const type = payment.payload.Payment.Type;
      // console.log("type: " + type)

      // console.log("payment.payload: " + JSON.stringify(payment.payload));
      //
      let cookie: any;

      switch (type) {
        case "Pix":
        case "PIX":
          const data = {"qrCodeBase64Image": result.data.payment.qrCodeBase64Image, "qrCodeString": result.data.payment.qrCodeString}
          cookie = {
            "type": type,
            "status": result.success,
            "letter_sent_id": this.param,
            "data": data //result.data.payCode
          }
          break;
        case "CreditCard":
          cookie = {
            "type": type,
            "status": result.success,
            'letter_sent_id': this.param,
            "data": null,
          }
          break;

      }
      sessionStorage.setItem("sbap-payed", JSON.stringify(cookie));

      waiting.close();
      this._router.navigate([ 'annuity-pay' ]);

    } else {
      waiting.close();
      this._dialog.open(AlertComponent, {
        width: '450px',
        height: '270px',
        panelClass: 'custom-dialog-container',
        data: {title: "Alerta", message: "Erro ao processar o pagamento!"}
      });
    }
  }

  async createAsaasPayment (payment: any) {
    const waiting = this._spinnerService.show();
    //
    const result = await this._asaasService.asaasPayment(payment);
    // const result = await this._asaasService.asaasPaymentDev(payment);
    // console.log("asaasPayment result.data: " + JSON.stringify(result.data))
    const type = payment.payload.billingType;
    // console.log("type: " + type)

    let cookie: any;
    switch (type) {
      case "PIX":
        cookie = {
          "type": type,
          "status": "success",
          'letter_sent_id': this.param,
          "data": result.data.payCode
        }
        break;
      case "BOLETO":
        const data = {"bankSlipUrl": result.data.payment.bankSlipUrl, ...result.data.payCode};
        cookie = {
          "type": type,
          "status": "success",
          'letter_sent_id': this.param,
          "data": data,
        }
        break;
      case "CREDIT_CARD":
        let status;
        if (result.data.payment.errors) {
          status = "error";
        } else {
          status = "success";
        }
        cookie = {
          "type": type,
          "status": status,
          'letter_sent_id': this.param,
          "data": null,
        }
        break;

    }

    sessionStorage.setItem("sbap-payed", JSON.stringify(cookie));

    waiting.close();
    this._router.navigate([ 'annuity-pay' ]);

  }

  clearErro () {
    this.msgErro = "";
  }

  createForm (): FormGroup {
    let form: FormGroup = this.fb.group({
      holderName: new FormControl("", [ Validators.required ]),
      number1: new FormControl("", [ Validators.required ]),
      number2: new FormControl("", [ Validators.required ]),
      number3: new FormControl("", [ Validators.required ]),
      number4: new FormControl("", [ Validators.required ]),
      expiryMonth: new FormControl("", [ Validators.required ]),
      expiryYear: new FormControl("", [ Validators.required ]),
      ccv: new FormControl("", [ Validators.required ])
    });

    return form;
  }

  createCreditCard (data: any) {

    const cardNumber = data.number1.toString() + data.number2.toString() + data.number3.toString() + data.number4.toString()
    const cardBrand = this._annuityLetterService.getCardBrand(cardNumber)
    const expiryMonthYear = data.expiryMonth + "/" + data.expiryYear
    // console.log("brand: " + cardBrand)
    const client = this.createClient()

    const payment = {
      "customer": "",
      "billingType": "CREDIT_CARD",
      "value": this.selectedOption.installments == 1 ? this.valueTotalAnnuitues : "",
      "totalValue": this.selectedOption.installments > 1 ? this.valueTotalAnnuitues : "",
      "installmentCount": this.selectedOption.installments > 1 ? this.selectedOption.installments : "",
      "installmentValue": this.selectedOption.installments > 1 ? this.selectedOption.value : "",
      "dueDate": new Date(),
      "externalReference": this.letter.order_id + ":" + this.param + ":" + this.valueTotalAnnuitues + ":" + this.selectedOption.installments + ":" + this.letter.credit + ":" + this.discountValue + ":" + this.origin,
      "description": CURRENT_ANNUITY_NAME,
      "creditCard": {
        "cardBrand": cardBrand,
        "holderName": data.holderName,
        "number": cardNumber,
        "expiryMonthYear": expiryMonthYear,
        "ccv": data.ccv
      },
      "creditCardHolderInfo": {
        "name": this.letter.name,
        "email": this.letter.email,
        "cpfCnpj": this.letter.cpf,
        "postalCode": this.letter.postalCode,
        "addressNumber": this.letter.number,
        "addressComplement": this.letter.complement,
        "mobilePhone": this.letter.cellPhone,
      },
      "remoteIp": ""
    }

    return {client: client, payload: payment};

  }

  createCreditCard_cielo (data: any) {

    const cardNumber = data.number1.toString() + data.number2.toString() + data.number3.toString() + data.number4.toString()
    // console.log("cardNumber: " + cardNumber);

    const expiryMonthYear = data.expiryMonth + "/" + data.expiryYear
    const cardBrand = this._annuityLetterService.getCardBrand(cardNumber)
    // console.log("brand: " + cardBrand)
    //const client = this.createClient()

    const MerchantOrderId: any = Guid.create();

    const payment_cielo = {
      "Customer": {
        "Name": this.letter.name,
        "Identity": this.letter.cpf,
        "IdentityType": "CPF",
        "Email": this.letter.email,
        // "Birthdate": "1990-01-01"
      },
      "Payment": {
        "Type": "CreditCard",
        "CreditCard": {
          "CardNumber": cardNumber,
          "Holder": data.holderName.toUpperCase(),
          "ExpirationDate": expiryMonthYear,
          "SecurityCode": data.ccv,
          "Brand": cardBrand,
        },
        "Amount": this.valueTotalAnnuitues,
        "Currency": "BRL",
        "Country": "BRA",
        "SoftDescriptor": CURRENT_ANNUITY_NAME,
        "Installments": this.selectedOption.installments,
        "Interest": "ByMerchant",
        "Capture": true,
        "Authenticate": false,
        "Recurrent": false,
      },
      "MerchantOrderId": MerchantOrderId.value
    }

    const externalReference = this.letter.order_id + ":" + this.param + ":" + this.valueTotalAnnuitues + ":" + this.selectedOption.installments + ":" + this.letter.credit + ":" + this.discountValue + ":" + this.origin

    return {gateway: "cielo", 'externalReference': externalReference, payload: payment_cielo};

  }

  createBillet () {
    const client = this.createClient()
    const payment = {
      "customer": "",
      "billingType": "BOLETO",
      "value": this.valueTotalAnnuitues,
      "dueDate": new Date(),
      "externalReference": this.letter.order_id + ":" + this.param + ":" + this.valueTotalAnnuitues + ":" + "1" + ":" + this.letter.credit + ":" + this.discountValue + ":" + this.origin,
      "description": CURRENT_ANNUITY_NAME,
      "postalService": false,
      "address": {
        "street": this.letter.address,
        "streetNumber": this.letter.number,
        "complement": this.letter.complement,
        "province": this.letter.district,
        "postalCode": this.letter.postalCode
      },
      "receiverName": this.letter.name
    }
    return {gateway: "assas", client: client, payload: payment};

  }

  createPix () {
    const client = this.createClient()
    const payment = {
      "customer": "",
      "billingType": "PIX",
      "value": this.valueTotalPixAnnuitues,
      "externalReference": this.letter.order_id + ":" + this.param + ":" + this.valueTotalAnnuitues + ":" + "1" + ":" + this.letter.credit + ":" + this.discountValue + ":" + this.origin,
      "description": CURRENT_ANNUITY_NAME,
      "dueDate": new Date()
    }
    return {gateway: "cielo", client: client, payload: payment};
  }

  createPix_cielo () {
    const MerchantOrderId: any = Guid.create();
    //
    const payment_cielo = {
      "Customer": {
        "Name": this.letter.name,
        "Identity": this.letter.cpf,
        "IdentityType": "CPF",
        "Email": this.letter.email,
        // "Birthdate": "1990-01-01"
      },
      "Payment": {
        "Type": "Pix",
        "Amount": this.valueTotalPixAnnuitues,
        "Provider": "Cielo2",
        "Currency": "BRL",
        "Country": "BRA",
        "QrCode": {
          "Expiration": 86400
        },
      },
      "MerchantOrderId": MerchantOrderId.value
    }

    const externalReference = this.letter.order_id + ":" + this.param + ":" + this.valueTotalAnnuitues + ":" + "" + ":" + this.letter.credit + ":" + this.discountValue + ":" + this.origin
    return {gateway: "cielo", 'externalReference': externalReference, payload: payment_cielo};
  }

  createClient () {
    return {
      "name": this.letter.name,
      "cpfCnpj": this.letter.cpf,
      "email": this.letter.email,
      "phone": this.letter.phonel,
      "foreignCustomer": this.letter.foreignCustomer ? this.letter.foreignCustomer : false
    }
  }


  formatDate (_date: any) {

    if (_date) {
      let date = new Date(_date.seconds * 1000)
      let dt = date.toISOString()

      let dd: any = dt.substring(8, 10);
      let mm: any = dt.substring(5, 7);
      let yy: any = dt.substring(0, 4);

      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  autoAdvance (event: Event, nextInput: HTMLInputElement): void {
    const input = event.target as HTMLInputElement;

    if (input.value.length === input.maxLength) {
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  autoRetreat (event: KeyboardEvent, prevInput: HTMLInputElement): void {
    const input = event.target as HTMLInputElement;

    // Verifica se a tecla é 'Backspace' E se o campo está vazio após a ação.
    if (event.key === 'Backspace' && input.value.length === 0) {
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  gerarRecibo () {
    const waiting = this._spinnerService.show();
    this._annuityLetterService.getLetterSentById(this.param)
      .then(async (result) => {
        if (result) {
          if (result.datePayed) {
            console.log("result orderId: " + result.order_id)
            const ret = await this._calableMemberService.requestReceipt(result.order_id)
            this.receiptMessage = "O recibo foi enviado ao e-mail cadastrado"
            waiting.close();
          }
        } else {
          waiting.close();
        }
      })
  }

}
